import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=ac2dfb10&scoped=true"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"
import style0 from "./Forbidden.vue?vue&type=style&index=0&id=ac2dfb10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2dfb10",
  null
  
)

export default component.exports